module.exports = {
      id: "clapboard-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#clapboard",
      toString: function () {
        return this.url;
      }
    }